import { on } from "delegated-events";

// import { preventScroll, allowScroll } from "./prevent-scroll";

const menuButton = document.querySelector("[data-toggle-menu]");
const headerInner = document.querySelector(".header-inner");
const menu = document.querySelector(".header nav");
const main = document.querySelector("main");
const footer = document.querySelector("footer");

document.documentElement.style.setProperty(
  "--header-height",
  `${headerInner.offsetHeight}px`
);

on("click", "[data-toggle-menu]", toggleMenu);

menu.addEventListener("keydown", (event) => {
  if (event.key === "Escape") hideMenu();
});

function toggleMenu() {
  const menu = document.querySelector(".header nav");
  menu.hidden ? showMenu() : hideMenu();
}

async function showMenu() {
  const menu = document.querySelector(".header nav");
  menu.hidden = false;
  menu.inert = false;
  main.inert = true;
  footer.inert = true;
  document.documentElement.classList.add("menu-open");
  menuButton.setAttribute("aria-expanded", true);
  menu.focus();
  // preventScroll();
}

/**
 * Show the fullscreen menu
 */
async function hideMenu() {
  // allowScroll();
  const menu = document.querySelector(".header nav");
  document.documentElement.classList.remove("menu-open");
  await new Promise((resolve) => setTimeout(resolve, 300));
  menu.hidden = true;
  menu.inert = true;
  main.inert = false;
  footer.inert = false;
  menuButton.setAttribute("aria-expanded", false);
  document.querySelector("[data-toggle-menu]").focus();
}
